export default __webpack_public_path__ + "static/media/plusSign.e149e757.jpg";